<template>
  <div>
    <b-modal id="serviceConfiguration" title="Service Hands-on-fees" size="xl">

      <template #modal-header>
        <div class="d-flex w-100 justify-content-left h2 text-primary">
          Service Hands-on-fees
        </div>
      </template>

      <div class="d-flex flex-column w-100">

        <div class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="panel-container">

          <div class="panel-content">

            <ul class="nav nav-tabs" role="tablist">
              <li class="nav-item" v-for="c of sections" :key="'section' + c.sectionID">
                <a :class="{ 'active': selectedSection['sectionID'] === c.sectionID }" class="nav-link" role="tab" @click="filterBySection(c)">
                  {{ c.name }}
                </a>
              </li>
            </ul>

            <table class="table">
              <tr>
                <th rowspan="2" style="text-align: center; vertical-align: middle; ">Service</th>
                <th colspan="3" style="text-align: center;">Hands-on Fee</th>
              </tr>
              <tr>
                <th>
                  <div style="display: flex; justify-content: space-between;">
                    <div>1 Staff </div>
                    <div>
                      Multistaff
                      <input type="checkbox" v-model="multistaff[selectedSection['sectionID']]" @change="multistaffChange"/>
                    </div>
                  </div>
                </th>
                <th v-if="multistaff[selectedSection['sectionID']]">2 Staffs (Staff 1)</th>
                <th v-if="multistaff[selectedSection['sectionID']]">2 Staffs (Staff 2)</th>
              </tr>
              <tr>
                <td colspan="2"><h6>Category</h6></td>
              </tr>
              <tr>
                <td>
                  <label class="form-label"><u>{{ selectedSection['name'] }}</u></label>
                </td>
                <td style="min-width: 250px">
                  <div style="display: flex" v-for="(item, index) of fee[selectedSection['sectionID']]" :key="'category' + index">
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['min']"
                      type="number"
                      :searchable="false"
                      :show-labels="false"
                      @change="onSeniorChange('', selectedSection['sectionID'], true)" />
                    <span style="margin-top: 10px">&nbsp;-&nbsp;</span>
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['max']"
                      type="number"
                      readonly
                      disabled
                      :searchable="false"
                      :show-labels="false" />
                    &nbsp;&nbsp;&nbsp;
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['fee']"
                      type="number"
                      :searchable="false"
                      :show-labels="false" />
                    <button type="button" class="btn btn-danger" @click="onSeniorRemove('', selectedSection['sectionID'], index)">x</button>
                  </div>
                  <button type="button" class="btn btn-primary" @click="onSeniorAdd('', selectedSection['sectionID'])">+</button>
                </td>
                <td v-if="multistaff[selectedSection['sectionID']]" style="min-width: 250px">
                  <div style="display: flex" v-for="(item, index) of fee1[selectedSection['sectionID']]" :key="'category' + index">
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['min']"
                      type="number"
                      :searchable="false"
                      :show-labels="false"
                      @change="onSeniorChange(1, selectedSection['sectionID'], true)" />
                    <span style="margin-top: 10px">&nbsp;-&nbsp;</span>
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['max']"
                      type="number"
                      readonly
                      disabled
                      :searchable="false"
                      :show-labels="false" />
                    &nbsp;&nbsp;&nbsp;
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['fee']"
                      type="number"
                      :searchable="false"
                      :show-labels="false" />
                    <button type="button" class="btn btn-danger" @click="onSeniorRemove(1, selectedSection['sectionID'], index)">x</button>
                  </div>
                  <button type="button" class="btn btn-primary" @click="onSeniorAdd(1, selectedSection['sectionID'])">+</button>
                </td>
                <td v-if="multistaff[selectedSection['sectionID']]" style="min-width: 250px">
                  <div style="display: flex" v-for="(item, index) of fee2[selectedSection['sectionID']]" :key="'category' + index">
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['min']"
                      type="number"
                      :searchable="false"
                      :show-labels="false"
                      @change="onSeniorChange(2, selectedSection['sectionID'], true)" />
                    <span style="margin-top: 10px">&nbsp;-&nbsp;</span>
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['max']"
                      type="number"
                      readonly
                      disabled
                      :searchable="false"
                      :show-labels="false" />
                    &nbsp;&nbsp;&nbsp;
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['fee']"
                      type="number"
                      :searchable="false"
                      :show-labels="false" />
                    <button type="button" class="btn btn-danger" @click="onSeniorRemove(2, selectedSection['sectionID'], index)">x</button>
                  </div>
                  <button type="button" class="btn btn-primary" @click="onSeniorAdd(2, selectedSection['sectionID'])">+</button>
                </td>
              </tr>
              <tr>
                <td colspan="2"><h6>Service List</h6></td>
              </tr>
              <tr v-for="(service, index) in selectedServices" :key="'service_' + index">
                <td>
                  <label class="form-label">{{ service['name'] }}</label>
                </td>
                <td style="min-width: 250px">
                  <div style="display: flex" v-for="(item, index) of fee[service['id']]" :key="'senior' + index">
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['min']"
                      type="number"
                      :searchable="false"
                      :show-labels="false"
                      @change="onSeniorChange('', service['id'], true)" />
                    <span style="margin-top: 10px">&nbsp;-&nbsp;</span>
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['max']"
                      type="number"
                      readonly
                      disabled
                      :searchable="false"
                      :show-labels="false" />
                    &nbsp;&nbsp;&nbsp;
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['fee']"
                      type="number"
                      :searchable="false"
                      :show-labels="false" />
                    <button type="button" class="btn btn-danger" @click="onSeniorRemove('', service['id'], index)">x</button>
                  </div>
                  <button type="button" class="btn btn-primary" @click="onSeniorAdd('', service['id'])">+</button>
                </td>
                <td v-if="multistaff[selectedSection['sectionID']]" style="min-width: 250px">
                  <div style="display: flex" v-for="(item, index) of fee1[service['id']]" :key="'senior' + index">
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['min']"
                      type="number"
                      :searchable="false"
                      :show-labels="false"
                      @change="onSeniorChange(1, service['id'], true)" />
                    <span style="margin-top: 10px">&nbsp;-&nbsp;</span>
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['max']"
                      type="number"
                      readonly
                      disabled
                      :searchable="false"
                      :show-labels="false" />
                    &nbsp;&nbsp;&nbsp;
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['fee']"
                      type="number"
                      :searchable="false"
                      :show-labels="false" />
                    <button type="button" class="btn btn-danger" @click="onSeniorRemove(1, service['id'], index)">x</button>
                  </div>
                  <button type="button" class="btn btn-primary" @click="onSeniorAdd(1, service['id'])">+</button>
                </td>
                <td v-if="multistaff[selectedSection['sectionID']]" style="min-width: 250px">
                  <div style="display: flex" v-for="(item, index) of fee2[service['id']]" :key="'senior' + index">
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['min']"
                      type="number"
                      :searchable="false"
                      :show-labels="false"
                      @change="onSeniorChange(2, service['id'], true)" />
                    <span style="margin-top: 10px">&nbsp;-&nbsp;</span>
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['max']"
                      type="number"
                      readonly
                      disabled
                      :searchable="false"
                      :show-labels="false" />
                    &nbsp;&nbsp;&nbsp;
                    <input
                      class="form-control"
                      style="width: 80px"
                      v-model="item['fee']"
                      type="number"
                      :searchable="false"
                      :show-labels="false" />
                    <button type="button" class="btn btn-danger" @click="onSeniorRemove(2, service['id'], index)">x</button>
                  </div>
                  <button type="button" class="btn btn-primary" @click="onSeniorAdd(2, service['id'])">+</button>
                </td>
              </tr>
            </table>

          </div>

        </div>
      </div>

      <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-end">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="save()">OK</b-button>
        </div>
      </template>

    </b-modal>

  </div>
</template>
<script>
import moment from 'moment'
import { calculateSalesReportTotal, getSubTotal } from '@/assets/js/dashboard/salonReport/salonReport.js'
import { getOutletName, handleSessionExpired } from '@/assets/js/dashboard/dashboard.js'
import { formatPrice, insertLeadingZero } from '@/assets/js/dashboard/utilities.js'
export default {
  name: "serviceConfiguration",
  data() {
    return {
      showLoading: false,
      outlets: [],
      sections: [],
      selectedSection: {},
      services: [],
      selectedServices: [],

      selectedOutlet: {},

      freeJunior: {},
      freeSenior: {},
      commJunior: {},
      fee: {},
      fee1: {},
      fee2: {},
      multistaff: {},
    }
  },
  watch: {
    selectedOutlet(val) {
      this.onOutletChange()
    }
  },
  methods: {
    open() {
      this.$bvModal.show('serviceConfiguration')
      this.loadSection()
    },

    onOutletChange() {
      this.effort = {}
      this.loadCommission()
    },

    filterBySection(val) {
      this.selectedSection = val
      this.selectedServices.splice(0, this.selectedServices.length)

      for (let service of this.services) {        
        if (service['section']['sectionID'] === 0) {
          service['section']['sectionID'] = this.sections[0]['sectionID']
        }
        if (service['section']['sectionID'] === this.selectedSection['sectionID']) {
          this.selectedServices.push({ id: service['skuID'], name: service['name'] })
        }
      }
    },

    loadSection() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sections?typeID=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.sections = response.data.sections
          this.selectedSection = this.sections[0]

          this.loadService()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadService() {
      this.showLoading = true

      this.$axios({
        method: 'get',
        url: 'https://menu.tunai.io/business/sku?typeID=1&enable=1',
        headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          this.services = response.data.skus
          this.filterBySection(this.selectedSection)
          this.onOutletChange()
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },
    loadCommission() {
      for(let service of this.sections) {
        this.fee[service['sectionID']] = [{ min: '', max: '', fee: '' }]
        this.fee1[service['sectionID']] = [{ min: '', max: '', fee: '' }]
        this.fee2[service['sectionID']] = [{ min: '', max: '', fee: '' }]
        this.multistaff[service['sectionID']] = false
      }
      for(let service of this.services) {
        this.fee[service['skuID']] = [{ min: '', max: '', fee: '' }]
        this.fee1[service['skuID']] = [{ min: '', max: '', fee: '' }]
        this.fee2[service['skuID']] = [{ min: '', max: '', fee: '' }]
      }
      
      this.showLoading = true

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_OriyaBeautyTaiping_fixedCommission_service_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_OriyaBeautyTaiping_fixedCommission_service_setting`
      }

      this.$axios({
        method: 'get',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
      })
        .then((response) => {
          this.showLoading = false
          for (let temp in response.data) {
            let setting = (response.data[temp] || {})
            this.fee[temp] = setting['fee'] || [{ min: '', max: '', fee: '' }]
            this.fee1[temp] = setting['fee1'] || [{ min: '', max: '', fee: '' }]
            this.fee2[temp] = setting['fee2'] || [{ min: '', max: '', fee: '' }]
            this.multistaff[temp] = setting['multistaff'] || false
            
            // this.fee[temp] = this.fee[temp].length == 0 ? [{}] : this.fee[temp]

            this.onSeniorChange('', temp)
            this.onSeniorChange(1, temp)
            this.onSeniorChange(2, temp)
          }

          this.$forceUpdate()
        })
        .catch((err) => {
          console.log(err)
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    save() {
      this.showLoading = true

      let request = {}
      for(let service of this.sections) {
        request[service['sectionID']] = {
          fee: this.fee[service['sectionID']],
          fee1: this.fee1[service['sectionID']],
          fee2: this.fee2[service['sectionID']],
          multistaff: this.multistaff[service['sectionID']],
        }
      }
      for (let service of this.services) {
        request[service['skuID']] = {
          fee: this.fee[service['skuID']],
          fee1: this.fee1[service['skuID']],
          fee2: this.fee2[service['skuID']],
        }
      }

      let url = `https://emerchant.tunai.io/setting2.php/${this.selectedOutlet.text}_OriyaBeautyTaiping_fixedCommission_service_setting`
      if (window.location.href.includes('localhost') || window.location.href.includes('127.0.0.1')) {
        url = `http://localhost:8080/setting2.php/${this.selectedOutlet.text}_OriyaBeautyTaiping_fixedCommission_service_setting`
      }

      this.$axios({
        method: 'post',
        url: url,
        // headers: { token: this.$util.getSessionToken() }
        data: request,
      })
        .then((response) => {
          this.showLoading = false

          this.$bvModal.hide('serviceConfiguration')
          this.$emit('modalClose');
        })
        .catch((err) => {
          this.showLoading = false

          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        })
    },

    onSeniorRemove(staff, serviceId, index) {
      this['fee' + (staff || '')][serviceId].splice(index, 1)
      this.onSeniorChange(serviceId)
      this.$forceUpdate()
    },
    onSeniorAdd(staff, serviceId) {
      this['fee' + (staff || '')][serviceId] = this['fee' + (staff || '')][serviceId] || []
      this['fee' + (staff || '')][serviceId].push({ min: '', max: '', fee: '' })
      this.$forceUpdate()
    },
    onSeniorChange(staff, serviceId, forceUpdate) {
      for (let i = 0; i < this['fee' + (staff || '')][serviceId].length; i++) {
        let min = parseFloat(this['fee' + (staff || '')][serviceId][i]['min'])
        if(i > 0 && !isNaN(min)) {
          this['fee' + (staff || '')][serviceId][i - 1]['max'] = min - 0.01
        }
      }

      if(forceUpdate) {
        this.$forceUpdate()
      }
    },

    multistaffChange() {
      this.$forceUpdate()
    },
  },
  mounted() {
    this.outlets = JSON.parse(this.$store.state.outlets)
    this.selectedOutlet = this.outlets[0]
  }
}
</script>
<style scoped>
.modal-content {
  background: transparent;
  box-shadow: none;
}

.month-picker-input-container {
  width: 100%;
}
</style>